import { loadStripe } from '@stripe/stripe-js';
import { useMemo, type ReactNode } from 'react';
import { Elements } from '@stripe/react-stripe-js';

function StripeProvider({
  children,
  publishKey,
  clientSecret,
}: {
  publishKey: string;
  children: ReactNode;
  clientSecret: string;
}) {
  const stripePromise = useMemo(() => loadStripe(publishKey), [publishKey]);
  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret,
        appearance: {
          theme: 'stripe',
          variables: {
            spacingUnit: '4px',
            borderRadius: '8px',
            colorText: '#363636',
            colorDanger: '#d64949',
            colorPrimary: '#000000',
            colorBackground: '#ffffff',
            fontFamily:
              'Plus Jakarta Sans, Source Sans Pro, Helvetica Neue, Helvetica, ui-sans-serif, system-ui, sans-serif',
          },
        },
      }}>
      {children}
    </Elements>
  );
}

export default StripeProvider;
